import { useQuery } from '@tanstack/react-query';
import { getActiveRepositories } from '../../api/edms/repositories';

function getRepositoriesList(response) {
  if (!response) return [];
  const d = response.data ?? response;
  if (Array.isArray(d?.repositories)) return d.repositories;
  if (Array.isArray(d)) return d;
  return [];
}

export const useActiveRepositories = (options = {}) => {
  const query = useQuery({
    queryKey: ['edms', 'repositories', 'active'],
    queryFn: getActiveRepositories,
    enabled: options.enabled !== false,
  });

  return {
    ...query,
    repositories: getRepositoriesList(query.data),
  };
};

export default useActiveRepositories;
